import React, { useState, useEffect } from 'react';
import './header.css';
import CTA from './CTA';
import ME from '../../assets/me.png';
import HeaderSocials from './HeaderSocials';
import { BiDownArrowAlt } from 'react-icons/bi';
import backgroundVideo from '../../assets/vid1.mp4';

const Header = () => {
   const titles = [
      "Frontend Developer", 
      "Web Designer", 
      "JavaScript Enthusiast"
   ];
   const [currentTitleIndex, setCurrentTitleIndex] = useState(0);

   useEffect(() => {
      const interval = setInterval(() => {
         setCurrentTitleIndex((prevIndex) => (prevIndex + 1) % titles.length);
      }, 2000); 

      return () => clearInterval(interval); 
   }, [titles.length]);

   return (
      <header className="header">

         <video 
            className="header__video-background" 
            autoPlay 
            loop 
            muted 
            playsInline
         >
         <source src={backgroundVideo} type="video/mp4" />
         Your browser does not support the video tag.
         </video>


         <div className="container header__container">
            <h2>Hello I'm</h2>
            <h1>ZAMIR SHAMS</h1>
            {/* Dynamic h5 title */}
            <h4 className="text-light dynamic-title">{titles[currentTitleIndex]}</h4>
            <CTA />
            <HeaderSocials />

            <div className="me">
               <img src={ME} alt="me" />
            </div>

            <a href="#contact" className="scroll__down">
               Scroll Down
               <BiDownArrowAlt className="scroll__down-icon" />
            </a>
         </div>
      </header>
   );
};

export default Header;
